import { z } from "zod";

import { healthVersionSchema } from "./version";

/**
 * Zod schema for `extensions.health.hrv` — a heart-rate-variability
 * summary captured either overnight (Garmin Body Battery / HRV Status)
 * or as a spot measurement.
 */
export const hrvSummarySchema = z.object({
  kind: z.literal("hrv"),
  version: healthVersionSchema,
  measuredAt: z.iso.datetime(),
  rMSSD: z.number().positive(),
  measurementWindow: z.enum(["overnight", "spot"]),
  score: z.number().int().min(0).max(100).optional(),
  kaiordRecordId: z.string().uuid().optional(),
  sourceBridgeId: z.string().optional(),
  externalId: z.string().optional(),
});

export type HrvSummary = z.infer<typeof hrvSummarySchema>;
